export default __webpack_public_path__ + "src/assets/social-telegram-white.8f8a6be9f454cb4c395b67687ffff4ed.svg";